import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {GpxFileInfo, MapService} from '../map.service';
import {ToastrService} from 'ngx-toastr';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-map-config',
  imports: [
    FormsModule
  ],
  templateUrl: './map-config.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './map-config.component.scss'
})
export class MapConfigComponent implements OnInit {

  fileInfos: GpxFileInfo[] = [];

  constructor(
    private mapService: MapService,
    private notificationService: ToastrService,
  ) {

  }


  ngOnInit(): void {
    this.mapService.getFileInfo().subscribe({
      next: res => this.fileInfos = res,
      error: err => this.notificationService.error('failed to read data: ' + JSON.stringify(err)),
    });
  }

  getActive(fileInfo: GpxFileInfo): boolean {
    return this.mapService.isFileActive(fileInfo.name);
  }

  toggleActive(fileInfo: GpxFileInfo) {
    const prevActive = this.mapService.isFileActive(fileInfo.name);
    this.mapService.setFileActive(fileInfo.name, !prevActive);
  }

  getFileColor(fileInfos: GpxFileInfo) {
    return this.mapService.getFileColor(fileInfos.name);
  }

  changeColor(fileInfo: GpxFileInfo, value: string, $event: Event) {
    this.mapService.setFileColor(fileInfo.name, value);
    $event.stopPropagation();
  }

  getDateFromLimit() {
    return this.mapService.getDateFromLimit();
  }

  getDateUntilLimit() {
    return this.mapService.getDateUntilLimit();
  }

  setDateFromLimit(text: string) {
    this.mapService.setDateFromLimit(text);
  }

  setDateUntilLimit(text: string) {
    this.mapService.setDateUntilLimit(text);
  }
}
